






















































import Vue from "vue";
import LinearLoader from "./LinearLoader.vue";
import Processing from "./table/Processing.vue";
import ThemeImg from "./ThemeImg.vue";

export default Vue.extend({
  components: { LinearLoader, ThemeImg, Processing },

  props: {
    noResults: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "No Results",
    },
    type: {
      type: String,
      default: "linear",
    },
    loading_text: {
      type: String,
      default: "Loading...",
    },
  },
  setup() {
    /**
     * @public
     * */
    const scroll_to_top = () => {
      const el = document.querySelector(".stateful-scroller");
      if (el) {
        el.scrollTo({ top: 0 });
      }
    };
    return {
      scroll_to_top,
    };
  },
});
